import axios from "axios";
import alertify from "alertifyjs";
import "../../node_modules/alertifyjs/build/css/alertify.css";
import "../../node_modules/alertifyjs/build/css/themes/semantic.css";

export const UpdatePostgreSQLStatus = "https://tan6tgboda.execute-api.ap-south-1.amazonaws.com/dev/UpdatePostgreSQLStatus";

const storedModuleId = localStorage.getItem("module_id")
const storedTaskId = localStorage.getItem("task_id")

const storedUserId = localStorage.getItem("UsersID");
const storedCourseId = localStorage.getItem("Course_ID")

const storedbatchid = localStorage.getItem("batch_id_match")

console.log("storedbatch is ",storedbatchid)

function getISTTimeString() {
  const now = new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}

const istISOString = getISTTimeString();

const params = {
  user_id: storedUserId,
  course_id: storedCourseId,
  module_id: storedModuleId,
  task_id: storedTaskId,
  last_updated: istISOString,
  batch_id: storedbatchid
};


const DataFetchFailed = (message) => {
  alertify.set("notifier", "position", "top-right");
  alertify.error("Data fetch Submition Failed", message);
};

export const ConstructorEventPost = async (api, data) => {
  try {
    const response = await axios.post(api, data);
    console.log(response);
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error(error, "error");
  }
};
//Edit
export const ConstructorEventGet = async (api, data) => {
  // const headers = {'authorizationToken': 'fadhil/fadhil.abdulla.456@gmail.com/G2G1GG378F'}

  try {
    const response = await axios.get(api, { params: data });
    return response.data;
  } catch (error) {
    console.error(error, "error");
    //DataFetchFailed(error.message)
  }
};

export const ConstructorEventGetNoParams = async (api, data) => {
  try {
    const response = await axios.get(api, data);
    return response.data;
  } catch (error) {
    console.error(error);
    //DataFetchFailed(error.message)
  }
};


export const ConstructorEventUpdateSQLStatus = async () => {
  try {
    const response = await axios.post(UpdatePostgreSQLStatus, params);
    console.log(response);
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error(error, "error");
  }
};